// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --account-course-br: .5rem;
  --account-course-border: 1px solid rgba(0, 0, 0, .4);

  --taalthuis-primary: #febc44;
  --taalthuis-secondary: #6aa2bf;
}

.my-course {
  overflow: hidden;
  border-top: var(--account-course-border);
  border-left: var(--account-course-border);
  border-right: var(--account-course-border);
}

.my-course:first-child {
  margin-top: 2rem;
  border-top-left-radius: var(--account-course-br);
  border-top-right-radius: var(--account-course-br);
}

.my-course:last-child {
  border-bottom-left-radius: var(--account-course-br);
  border-bottom-right-radius: var(--account-course-br);

  border-bottom: var(--account-course-border);
}

.my-course > * {
  padding: .5em;
  /*width: 100%;*/
}

.my-course > .course-links {
  font-weight: 600;
  display: flex;
  justify-content: stretch;
  padding: 0;
}

.my-course .course-links .links {
  font-weight: 400;
  display: inline-flex;
  flex: 1;
}

.my-course .course-links .cancel-button {
    border-style: solid;
    border-color: rgba(0, 0, 0, .4);
    border-width: 1px 1px 0 0;

    padding: .25em;
    flex: 1;
    text-align: center;

    color: #fff;
    font-weight: 700;
    background-color: #fe4444;
}

.my-course .course-links .cancel-button:last-child {
    border-right-width: 0;
}

.my-course .course-links .link {
  border-style: solid;
  border-color: rgba(0, 0, 0, .4);
  border-width: 1px 1px 0 0;

  padding: .25em;
  flex: 1;
  text-align: center;
}

.my-course .course-links .link:last-child {
  border-right-width: 0;
}

.my-courses-container {
  max-width: 750px;
  margin: 0 auto;
}

.my-course .course-status {
  padding: .25rem .5rem;

  border-bottom: 1px solid rgba(0, 0, 0, .4);
  border-right: 1px solid rgba(0, 0, 0, .4);
  border-bottom-right-radius: 3px;

  text-transform: uppercase;

  background: var(--taalthuis-secondary);
  color: white;
}

.my-course .cancel-order-modal {
    display: none; /* Hidden by default */
    position: fixed; /* Stay in place */
    z-index: 1; /* Sit on top */
    left: 0;
    top: 0;
    width: 100%; /* Full width */
    height: 100%; /* Full height */
    overflow: auto; /* Enable scroll if needed */
    background-color: rgba(0,0,0,0.4); /* Black w/ opacity */
}

/* Modal Content */

.cancel-order-modal .modal-content {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background-color: #fefefe;
    margin: auto;
    padding: 20px;
    border: 1px solid #888;
    width: 35vw;
}

.cancel-order-modal .modal-content .title {
    font-size: 1.5rem;
    margin-top: 0;
    font-weight: 700;
    width: 95%;
}

.cancel-order-modal .modal-content .description {
    margin-bottom: 0.5rem;
}

.cancel-order-modal .modal-content .buttons {
    display: flex;
    align-items: center;
    gap: 1rem;
    width: 15vw;
}

.cancel-order-modal .modal-content .buttons button {
    padding: .25em;
    flex: 1;
    text-align: center;
    width: -moz-max-content;
    width: max-content;

    border-width: 0;
    border-radius: 3px;

    font-weight: 700;
}

.cancel-order-modal .modal-content .buttons button.accept {
    background-color: #fe4444;
    color: #fff;
}

.cancel-order-modal .modal-content .buttons button.decline {
    background-color: #e4e4e4;
    color: #868686;
}

/* The Close Button */

.cancel-order-modall .close {
    color: #aaaaaa;
    float: right;
    font-size: 28px;
    font-weight: bold;
    z-index: 2;
}

.cancel-order-modal .close:hover,
.cancel-order-modal .close:focus {
    color: #000;
    text-decoration: none;
    cursor: pointer;
}

.course-title {
  font-weight: 600;
  margin-top: .25rem;
  display: inline-flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.course-passed {
  background: var(--taalthuis-primary);
  color: white;
  padding: .25rem .5rem;
  border-radius: .25rem;
}

.course-desc {
  display: flex;
  justify-content: space-between;
}

.course-desc-left {
  flex: 60% 1 1;
}

.course-desc-right {
  flex-grow: 1;
  flex-shrink: 1;
  text-align: right;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
}

.course-elearn-modules {
  margin: 0 -.5rem -.5rem;
}

.course-elearn-module {
  padding: 0 .25rem;

  border-left: 1px solid rgba(0, 0, 0, .4);
  background: var(--taalthuis-secondary);
  color: white;
}

.course-elearn-module:first-child {
  border-top: 1px solid rgba(0, 0, 0, .4);
  border-top-left-radius: 3px;
}

.course-elearn-module:not(:last-child) {
  border-bottom: 1px solid rgba(255, 255, 255, .4);
}
`, "",{"version":3,"sources":["webpack://./assets/src/scss/my-courses.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B,oDAAoD;;EAEpD,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,wCAAwC;EACxC,yCAAyC;EACzC,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,gDAAgD;EAChD,iDAAiD;AACnD;;AAEA;EACE,mDAAmD;EACnD,oDAAoD;;EAEpD,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,wBAAwB;EACxB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,OAAO;AACT;;AAEA;IACI,mBAAmB;IACnB,+BAA+B;IAC/B,yBAAyB;;IAEzB,cAAc;IACd,OAAO;IACP,kBAAkB;;IAElB,WAAW;IACX,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,yBAAyB;;EAEzB,cAAc;EACd,OAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,qBAAqB;;EAErB,0CAA0C;EAC1C,yCAAyC;EACzC,+BAA+B;;EAE/B,yBAAyB;;EAEzB,sCAAsC;EACtC,YAAY;AACd;;AAEA;IACI,aAAa,EAAE,sBAAsB;IACrC,eAAe,EAAE,kBAAkB;IACnC,UAAU,EAAE,eAAe;IAC3B,OAAO;IACP,MAAM;IACN,WAAW,EAAE,eAAe;IAC5B,YAAY,EAAE,gBAAgB;IAC9B,cAAc,EAAE,4BAA4B;IAC5C,iCAAiC,EAAE,qBAAqB;AAC5D;;AAEA,kBAAkB;;AAClB;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,gCAAgC;IAChC,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,cAAc;IACd,OAAO;IACP,kBAAkB;IAClB,uBAAkB;IAAlB,kBAAkB;;IAElB,eAAe;IACf,kBAAkB;;IAElB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAGA,qBAAqB;;AACrB;IACI,cAAc;IACd,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,UAAU;AACd;;AAEA;;IAEI,WAAW;IACX,qBAAqB;IACrB,eAAe;AACnB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,yBAAyB;EACzB,qBAAqB;AACvB;;AAGA;EACE,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;;EAEjB,wCAAwC;EACxC,sCAAsC;EACtC,YAAY;AACd;;AAEA;EACE,uCAAuC;EACvC,2BAA2B;AAC7B;;AAEA;EACE,gDAAgD;AAClD","sourcesContent":[":root {\n  --account-course-br: .5rem;\n  --account-course-border: 1px solid rgba(0, 0, 0, .4);\n\n  --taalthuis-primary: #febc44;\n  --taalthuis-secondary: #6aa2bf;\n}\n\n.my-course {\n  overflow: hidden;\n  border-top: var(--account-course-border);\n  border-left: var(--account-course-border);\n  border-right: var(--account-course-border);\n}\n\n.my-course:first-child {\n  margin-top: 2rem;\n  border-top-left-radius: var(--account-course-br);\n  border-top-right-radius: var(--account-course-br);\n}\n\n.my-course:last-child {\n  border-bottom-left-radius: var(--account-course-br);\n  border-bottom-right-radius: var(--account-course-br);\n\n  border-bottom: var(--account-course-border);\n}\n\n.my-course > * {\n  padding: .5em;\n  /*width: 100%;*/\n}\n\n.my-course > .course-links {\n  font-weight: 600;\n  display: flex;\n  justify-content: stretch;\n  padding: 0;\n}\n\n.my-course .course-links .links {\n  font-weight: 400;\n  display: inline-flex;\n  flex: 1;\n}\n\n.my-course .course-links .cancel-button {\n    border-style: solid;\n    border-color: rgba(0, 0, 0, .4);\n    border-width: 1px 1px 0 0;\n\n    padding: .25em;\n    flex: 1;\n    text-align: center;\n\n    color: #fff;\n    font-weight: 700;\n    background-color: #fe4444;\n}\n\n.my-course .course-links .cancel-button:last-child {\n    border-right-width: 0;\n}\n\n.my-course .course-links .link {\n  border-style: solid;\n  border-color: rgba(0, 0, 0, .4);\n  border-width: 1px 1px 0 0;\n\n  padding: .25em;\n  flex: 1;\n  text-align: center;\n}\n\n.my-course .course-links .link:last-child {\n  border-right-width: 0;\n}\n\n.my-courses-container {\n  max-width: 750px;\n  margin: 0 auto;\n}\n\n.my-course .course-status {\n  padding: .25rem .5rem;\n\n  border-bottom: 1px solid rgba(0, 0, 0, .4);\n  border-right: 1px solid rgba(0, 0, 0, .4);\n  border-bottom-right-radius: 3px;\n\n  text-transform: uppercase;\n\n  background: var(--taalthuis-secondary);\n  color: white;\n}\n\n.my-course .cancel-order-modal {\n    display: none; /* Hidden by default */\n    position: fixed; /* Stay in place */\n    z-index: 1; /* Sit on top */\n    left: 0;\n    top: 0;\n    width: 100%; /* Full width */\n    height: 100%; /* Full height */\n    overflow: auto; /* Enable scroll if needed */\n    background-color: rgba(0,0,0,0.4); /* Black w/ opacity */\n}\n\n/* Modal Content */\n.cancel-order-modal .modal-content {\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n    background-color: #fefefe;\n    margin: auto;\n    padding: 20px;\n    border: 1px solid #888;\n    width: 35vw;\n}\n\n.cancel-order-modal .modal-content .title {\n    font-size: 1.5rem;\n    margin-top: 0;\n    font-weight: 700;\n    width: 95%;\n}\n\n.cancel-order-modal .modal-content .description {\n    margin-bottom: 0.5rem;\n}\n\n.cancel-order-modal .modal-content .buttons {\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n    width: 15vw;\n}\n\n.cancel-order-modal .modal-content .buttons button {\n    padding: .25em;\n    flex: 1;\n    text-align: center;\n    width: max-content;\n\n    border-width: 0;\n    border-radius: 3px;\n\n    font-weight: 700;\n}\n\n.cancel-order-modal .modal-content .buttons button.accept {\n    background-color: #fe4444;\n    color: #fff;\n}\n\n.cancel-order-modal .modal-content .buttons button.decline {\n    background-color: #e4e4e4;\n    color: #868686;\n}\n\n\n/* The Close Button */\n.cancel-order-modall .close {\n    color: #aaaaaa;\n    float: right;\n    font-size: 28px;\n    font-weight: bold;\n    z-index: 2;\n}\n\n.cancel-order-modal .close:hover,\n.cancel-order-modal .close:focus {\n    color: #000;\n    text-decoration: none;\n    cursor: pointer;\n}\n\n.course-title {\n  font-weight: 600;\n  margin-top: .25rem;\n  display: inline-flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n}\n\n.course-passed {\n  background: var(--taalthuis-primary);\n  color: white;\n  padding: .25rem .5rem;\n  border-radius: .25rem;\n}\n\n.course-desc {\n  display: flex;\n  justify-content: space-between;\n}\n\n.course-desc-left {\n  flex: 60% 1 1;\n}\n\n.course-desc-right {\n  flex-grow: 1;\n  flex-shrink: 1;\n  text-align: right;\n  display: flex;\n  justify-content: flex-end;\n  align-items: flex-end;\n}\n\n\n.course-elearn-modules {\n  margin: 0 -.5rem -.5rem;\n}\n\n.course-elearn-module {\n  padding: 0 .25rem;\n\n  border-left: 1px solid rgba(0, 0, 0, .4);\n  background: var(--taalthuis-secondary);\n  color: white;\n}\n\n.course-elearn-module:first-child {\n  border-top: 1px solid rgba(0, 0, 0, .4);\n  border-top-left-radius: 3px;\n}\n\n.course-elearn-module:not(:last-child) {\n  border-bottom: 1px solid rgba(255, 255, 255, .4);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
